import {
  InviteCreateParams,
  InvitesApi,
  Program,
  ProgramCreateParams,
  ProgramsApi,
} from '@citruscamps/citrus-client'
import { sendEvent } from '../../../../../lib/gtag'
import { generateApiConfig } from '../../../../../utils/client-config'
import { useRequestHandler } from '../../../../../hooks/useRequestHandler'

interface ITrackingAction {
  step: string
  value?: number
  currency?: string
  items?: any[]
}

interface ISetupProgram {
  handleTrackAction: (action: ITrackingAction) => void
  handleCreate: (values: ProgramCreateParams) => Promise<Program>
  handleCreateInvite: (inputs: InviteCreateParams) => Promise<any>
}

export const useSetupProgram = (): ISetupProgram => {
  const { requestHandler } = useRequestHandler()
  const handleTrackAction = ({ step, value, currency, items }: ITrackingAction) => {
    sendEvent({
      label: 'Next',
      category: 'Lead',
      step,
      action: 'sign_up',
      ...(value && currency ? { value, currency } : {}),
      ...(items ? { items } : {}),
    })
  }

  const handleCreate = async (values: ProgramCreateParams) => {
    const programClient = new ProgramsApi(generateApiConfig())
    const program: Program = await requestHandler<Program>(() =>
      programClient.setupProgramProgram({ ProgramCreateParams: values }),
    )
    return program
  }

  const handleCreateInvite = async (values: InviteCreateParams) => {
    const inviteClient = new InvitesApi(generateApiConfig())
    await requestHandler(() =>
      inviteClient.createProgramInvite({
        program_id: values.program_id,
        InviteCreateParams: values,
      }),
    )
  }

  return {
    handleTrackAction,
    handleCreate,
    handleCreateInvite,
  }
}
